import { forwardRef } from 'react';

import {
  CheckboxCardProps,
  CheckboxGroupProps,
  CheckboxProps,
  Checkbox as MantineCheckbox,
} from '@mantine/core';

import classes from './checkbox.module.css';

const Checkbox_ = forwardRef<HTMLInputElement, CheckboxProps>(({ label, ...props }, ref) => {
  return (
    <MantineCheckbox
      ref={ref}
      label={typeof label === 'string' && props.required ? `${label} *` : label}
      {...props}
    />
  );
});

Checkbox_.displayName = 'Checkbox';

const { Indicator, Group, Card } = MantineCheckbox;

const Checkbox__ = Object.assign(Checkbox_, { Indicator, Group, Card });

const CheckboxDefaultProps = {
  radius: '4px',
  size: 'md',
};

const CheckboxDefaults = MantineCheckbox.extend({
  defaultProps: CheckboxDefaultProps,
  classNames: {
    input: classes.input,
    label: classes.label,
    icon: classes.icon,
  },
});

const CheckboxIndicatorDefaults = MantineCheckbox.Indicator.extend({
  defaultProps: CheckboxDefaultProps,
  classNames: {
    indicator: classes.input,
    icon: classes.icon,
  },
});

export { Checkbox__ as Checkbox, CheckboxDefaults, CheckboxIndicatorDefaults };
export type { CheckboxCardProps, CheckboxGroupProps, CheckboxProps };
